import * as React from 'react';
import { getValue } from '../utils';
import { getWeek, getQuarter, getMonth, getYear, isSameDay, isAfter } from '../utils/date-fns';
export default function useRangeDisabled(_ref, disabledStart, disabledEnd) {
  var picker = _ref.picker,
      selectedValue = _ref.selectedValue,
      disabledDate = _ref.disabledDate,
      disabled = _ref.disabled;
  var startDate = getValue(selectedValue, 0);
  var endDate = getValue(selectedValue, 1);

  function weekNumber(date) {
    var year = getYear(date);
    var week = getWeek(date);
    return year * 100 + week;
  }

  function monthNumber(date) {
    var year = getYear(date);
    var month = getMonth(date);
    return year * 100 + month;
  }

  function quarterNumber(date) {
    var year = getYear(date);
    var quarter = getQuarter(date);
    return year * 10 + quarter;
  }

  var disabledStartDate = React.useCallback(function (date) {
    if (disabledDate && disabledDate(date)) {
      return true;
    }

    if (disabled[1] && endDate) {
      return !isSameDay(date, endDate) && isAfter(date, endDate);
    }

    if (disabledStart && endDate) {
      switch (picker) {
        case 'quarter':
          return quarterNumber(date) > quarterNumber(endDate);

        case 'month':
          return monthNumber(date) > monthNumber(endDate);

        case 'week':
          return weekNumber(date) > weekNumber(endDate);

        default:
          return !isSameDay(date, endDate) && isAfter(date, endDate);
      }
    }

    return false;
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [disabledDate, disabled[1], endDate, disabledStart]);
  var disabledEndDate = React.useCallback(function (date) {
    if (disabledDate && disabledDate(date)) {
      return true;
    }

    if (disabled[0] && startDate) {
      return !isSameDay(date, endDate) && isAfter(startDate, date);
    }

    if (disabledEnd && startDate) {
      switch (picker) {
        case 'quarter':
          return quarterNumber(date) < quarterNumber(startDate);

        case 'month':
          return monthNumber(date) < monthNumber(startDate);

        case 'week':
          return weekNumber(date) < weekNumber(startDate);

        default:
          return !isSameDay(date, startDate) && isAfter(startDate, date);
      }
    }

    return false;
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [disabledDate, disabled[0], startDate, disabledEnd]);
  return [disabledStartDate, disabledEndDate];
}